module.exports = __webpack_public_path__ + "static/tune_in-0aa8406af47a73a3917eda90ece7ed05.png";